// extracted by mini-css-extract-plugin
export default {"cls1":"rbTDJUlYgsUSLESAAdXw","cls2":"_1HykspgiLbQ1q9aLKCx rbTDJUlYgsUSLESAAdXw"};